import React from 'react';

export default function ConfirmRemove() {
  return <p>Está ação não poderá mais ser desfeita.</p>;
}
